import { render, staticRenderFns } from "./AcceptTermsOfService.vue?vue&type=template&id=c20206a0&"
import script from "./AcceptTermsOfService.vue?vue&type=script&lang=js&"
export * from "./AcceptTermsOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports